export default __webpack_public_path__ + "static/media/Energy.05e23ff0.svg";